import { Component, Injector, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl, Validators } from '@angular/forms';

@Component({
  selector: 'split-checking-account-input',
  templateUrl: './split-checking-account-input.component.html',
  styleUrls: ['./split-checking-account-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SplitCheckingAccountInputComponent),
      multi: true,
    },
  ],
})
export class SplitCheckingAccountInputComponent implements ControlValueAccessor {

  @Input() required!: string;
  @Input() label!: string;

  onChange: any = () => {};
  onTouched: any = () => {};
  
  protected disabled!: boolean;


  protected account: any = null;

  protected digit: any = null;

  protected ngControl!: NgControl;

  protected validators = Validators;


  constructor(private injector: Injector) {}

  ngOnInit() {
    this.ngControl = this.injector.get(NgControl);
  }

  writeValue(value: any): void {
    if (value) {
      const [account, digit] = value.split('-');
      this.account = account;
      this.digit = digit;
    } else {
      this.account = null;
      this.digit = null;
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled
  }

  onModelChange(type: "DIGIT" | "ACCOUNT", value: any) { 
    if(type === "DIGIT") {
      this.digit = value;
    } else {
      this.account = value;
    }

    if(this.account && this.digit) {
      value = `${this.account}-${this.digit}`;
      this.onChange(value);
      this.onTouched();
    }
  }

  onBlur(): void {
    if (this.onTouched) {
      this.onTouched();
    }
  }

}